import React, { useState, useEffect } from 'react';
import BackButton from './BackButton';
import PurseCommon from './images/shop_img_chest_close_l_00.png';
import PurseUnCommon from './images/shop_img_chest_close_l_01.png';
import PurseRare from './images/shop_img_chest_close_l_02.png';
import PurseUltraRare from './images/shop_img_chest_close_l_03.png';
import PurseLegendary from './images/shop_img_chest_close_l_04.png';
import Ticket from './images/LotteryTicket.png';
import AntFood from './images/AntFood.png';
import Potion from './images/LevelingPotion.png';
import PurseOpenPopup from './PurseOpenPopup';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';

function InventoryPurse({ changeActiveComponent, selectedChestItemInfo, onClose }) {
    const [selectedPurse, setSelectedPurse] = useState(null);
    const [rewardInfo, setRewardInfo] = useState({});
    const [rewardedData, setRewardedData] = useState({})
    const [loading, setLoading] = useState(false);
    const { chestOpenHandler, fetchAllBalances } = useSolanaWeb3();


    // Define reward amounts and images based on the chest's category index or rarity
    const chestRewards = [
        { name: 'Common', image: PurseCommon, className: 'item-chest-common', lotteryTicketRewardAmount: 10, antFoodRewardAmount: 5, levelingPotionRewardAmount: 1 },
        { name: 'Uncommon', image: PurseUnCommon, className: 'item-chest-uncommon', lotteryTicketRewardAmount: 25, antFoodRewardAmount: 10, levelingPotionRewardAmount: 1 },
        { name: 'Rare', image: PurseRare, className: 'item-chest-rare', lotteryTicketRewardAmount: 30, antFoodRewardAmount: 10, levelingPotionRewardAmount: 1 },
        { name: 'UltraRare', image: PurseUltraRare, className: 'item-chest-ultrarare', lotteryTicketRewardAmount: 50, antFoodRewardAmount: 20, levelingPotionRewardAmount: 2 },
        { name: 'Legendary', image: PurseLegendary, className: 'item-chest-legendary', lotteryTicketRewardAmount: 100, antFoodRewardAmount: 50, levelingPotionRewardAmount: 5 },
    ];

    useEffect(() => {
        if (selectedChestItemInfo) {
            const chestData = chestRewards[selectedChestItemInfo.categoryIndex];
            setRewardInfo({
                image: chestData.image,
                className: chestData.className,
                name: chestData.name,
                lotteryTicketRewardAmount: chestData.lotteryTicketRewardAmount,
                antFoodRewardAmount: chestData.antFoodRewardAmount,
                levelingPotionRewardAmount: chestData.levelingPotionRewardAmount,
            });
        }
    }, [selectedChestItemInfo]);

    const handlePurseClick = async () => {
        setLoading(true);
        let data = undefined;
        switch (rewardInfo.className) {
            case "item-chest-common":
                data = await chestOpenHandler("item-chest-common");
                break;
            case "item-chest-uncommon":
                data = await chestOpenHandler("item-chest-uncommon");
                break;
            case "item-chest-rare":
                data = await chestOpenHandler("item-chest-rare");
                break;
            case "item-chest-ultrarare":
                data = await chestOpenHandler("item-chest-ultrarare");
                break;
            case "item-chest-legendary":
                data = await chestOpenHandler("item-chest-legendary");
                break;
            default:
                break;
        }
        // Simulate the action of opening a chest
        await fetchAllBalances()
        setRewardedData(data)
        setTimeout(() => {
            setSelectedPurse("openpurse");
            setLoading(false);
        }, 2000); // Simulate loading time
    };

    return (
        <section id="inventory-purse">
            <div className="inventory-container-right">
                <div className="active-item-header-content">
                    <div className={`inventory-item-active ${rewardInfo.className}`}><img src={rewardInfo.image} alt="Chest" /></div>
                    <div className="active-item-header"><h2>{rewardInfo.name} Chest</h2><p>Item</p></div>
                    <div className="descrition"><p>Open chests to obtain items & ANT Food. Rewards vary based on the chest's rarity.</p></div>
                </div>
                <div className="active-item-stats-top" id="chestrewards"><div className="line2"></div><h2>REWARDS</h2><div className="line2"></div></div>
                <div className="rewards-descrition"><p>You get one of the following rewards:</p></div>
                <div className="active-item-stats" id="chest-reward-stats">
                <div className="active-item-stat"><img src={Ticket} alt="Lottery Ticket" /><p>{rewardInfo.lotteryTicketRewardAmount} Lottery Ticket(s)</p></div>
                <div className="active-item-stat"><img src={AntFood} alt="Ant Food" /><p>{rewardInfo.antFoodRewardAmount} Ant Food</p></div>
                <div className="active-item-stat"><img src={Potion} alt="Leveling Potion" /><p>{rewardInfo.levelingPotionRewardAmount} Leveling Potion(s)</p></div>
                </div>
                <div className="active-item-buttons-container">
                    <button className="active-item-button-upper" disabled={loading} onClick={handlePurseClick}>
                    {loading ? "Opening..." : "OPEN CHEST"} 
                </button>
                <button className="active-item-button-lower" onClick={() => changeActiveComponent('shop')}>
                    BUY MORE CHESTS
                </button></div>
            </div>
            {selectedPurse === 'openpurse' && <PurseOpenPopup rewardedData={rewardedData} rewardInfo={rewardInfo} onClose={() => setSelectedPurse(null)} />}
        </section>
    );
}
export default InventoryPurse;